import React from "react";

export const PleaseWait=()=>{
return(
    <>
    <div><h2></h2></div>
</>
) 
}